import api from "../api";

export interface CommunityVoice {
  avatarAlt?: string;
  avatarUrl?: string;
  category: string;
  createdAt?: string;
  featured: boolean;
  hidden: boolean;
  id: string;
  isActive: boolean;
  name: string;
  order?: number;
  testimonial: string;
  title: string;
  updatedAt?: string;
}

function mapVoice(v: any, idx = 0): CommunityVoice {
  return {
    avatarAlt: v.full_name ? `${v.full_name} avatar` : "",
    avatarUrl: v.avatar_url ?? "",
    category: v.category,
    createdAt: v.created_at,
    featured: !!v.featured,
    hidden: !!v.hidden,
    id: String(v.id),
    isActive: !v.hidden,
    name: v.full_name,
    order: idx,
    testimonial: v.testimonial,
    title: v.title_position,
    updatedAt: v.updated_at,
  };
}

export const CommunityVoiceService = {
  create: async (
    data: CommunityVoice,
    avatarFile?: File,
  ): Promise<CommunityVoice> => {
    const formData = new FormData();
    formData.append("full_name", data.name);
    formData.append("title_position", data.title);
    formData.append("category", data.category);
    formData.append("testimonial", data.testimonial);
    formData.append("featured", data.featured ? "1" : "0");
    formData.append("hidden", data.isActive ? "0" : "1");
    if (avatarFile) {
      formData.append("avatar", avatarFile);
    } else if (data.avatarUrl) {
      formData.append("avatar_url", data.avatarUrl);
    }
    const response = await api.post("/community-voices", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return mapVoice(response.data.voice);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/community-voices/${id}`);
  },

  feature: async (id: string): Promise<CommunityVoice> => {
    const response = await api.post(`/community-voices/${id}/feature`);
    return mapVoice(response.data.voice);
  },

  getAll: async (): Promise<CommunityVoice[]> => {
    const response = await api.get("/community-voices");
    return (response.data.voices || []).map(mapVoice);
  },

  hide: async (id: string): Promise<CommunityVoice> => {
    const response = await api.post(`/community-voices/${id}/hide`);
    return mapVoice(response.data.voice);
  },

  unfeature: async (id: string): Promise<CommunityVoice> => {
    const response = await api.post(`/community-voices/${id}/unfeature`);
    return mapVoice(response.data.voice);
  },

  unhide: async (id: string): Promise<CommunityVoice> => {
    const response = await api.post(`/community-voices/${id}/unhide`);
    return mapVoice(response.data.voice);
  },

  update: async (id: string, data: CommunityVoice): Promise<CommunityVoice> => {
    const payload = {
      avatar_url: data.avatarUrl,
      category: data.category,
      featured: data.featured ? 1 : 0,
      full_name: data.name,
      hidden: data.isActive ? 0 : 1,
      testimonial: data.testimonial,
      title_position: data.title,
    };
    const response = await api.post(`/community-voices/${id}`, payload);
    return mapVoice(response.data.voice);
  },
};
